export const MODEL_SETTING = {
    MODEL_REGION: [
        { id: "USEast", value: "US East" },
        { id: "USWest", value: "US West" },
        { id: "USSaltLake", value: "US Saltlake" },
        { id: "Singapore", value: "Singapore" },
        { id: "Thailand", value: "Thailand" },
    ]
};